"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _excluded = ["spaces", "visible", "className", "compact"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledFlex = (0, _styledComponents["default"])(_.Flex).withConfig({
  displayName: "AttentionSpanContainerGrid___StyledFlex",
  componentId: "sstv42-0"
})(["width:", " background-color:rgb(32,42,61);position:absolute;padding-left:10px;z-index:1;height:25px;"], function (p) {
  return p._css;
});

var _StyledFlex2 = (0, _styledComponents["default"])(_.Flex).withConfig({
  displayName: "AttentionSpanContainerGrid___StyledFlex2",
  componentId: "sstv42-1"
})(["position:relative;margin-left:", ""], function (p) {
  return p._css2;
});

var _StyledFlex3 = (0, _styledComponents["default"])(_.Flex).withConfig({
  displayName: "AttentionSpanContainerGrid___StyledFlex3",
  componentId: "sstv42-2"
})(["text-align:center;box-sizing:border-box;border-right:1px solid transparent;&:last{border-right:none;}"]);

var AttentionSpanContainerGrid = function AttentionSpanContainerGrid(_ref) {
  var spaces = _ref.spaces,
      visible = _ref.visible,
      className = _ref.className,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_.Flex, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_.Flex, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_StyledFlex, {
    shrink: true,
    _css: compact ? '25px;' : '125px;'
  }), /*#__PURE__*/_react["default"].createElement(_StyledFlex2, {
    container: true,
    col: "auto",
    _css2: compact ? '35px;' : '135px;'
  }, Array.from(Array(24).keys()).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_StyledFlex3, {
      key: item,
      col: "auto"
    }, item, ":00");
  }))), spaces.map(function (space, index) {
    return /*#__PURE__*/_react["default"].createElement(_.AttentionSpanGridRow, _extends({
      key: index,
      id: index + 1 // compact={compact}
      // editable={editable}

    }, space, props));
  }));
};

AttentionSpanContainerGrid.propTypes = {
  /** Nombre de la clase que se concatena a la existente al elemento raíz con un espacio intermedio. */
  className: _propTypes["default"].string,

  /** Listado de objetos que contiene la información de cada una de las filas. Por cada uno de estos objetos, se dibuja una fila. */
  spaces: _propTypes["default"].array,

  /** Indica si el componente esta visible o no. */
  visible: _propTypes["default"].bool,

  /** Indica si el componente esta en modo compacto o no. */
  compact: _propTypes["default"].bool // /** Indica si el componente esta en modo compacto o no. */
  // editable: PropTypes.bool

};
var _default = AttentionSpanContainerGrid;
exports["default"] = _default;